import api from "./api";
import handleApiError from "./errorHandler";
import { toast } from "react-toastify";

type RequestOptions = {
  headers?: Record<string, string>;
  params?: Record<string, any>;
  skipToast?: boolean;
};

const getRequestConfig = (data?: any, options?: RequestOptions) => {
  let headers: Record<string, string> = {};

  // Auto-set multipart content-type if data is FormData
  if (data instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }

  // Merge custom headers (if any)
  if (options?.headers) {
    headers = { ...headers, ...options.headers };
  }

  // Return final config object for Axios
  return {
    headers: Object.keys(headers).length ? headers : undefined,
    params: options?.params,
    skipToast: options?.skipToast,
  };
};

export const httpService = {
  get: async <T>(url: string, options?: RequestOptions): Promise<T> => {
    try {
      const config = getRequestConfig(undefined, options);
      const response = await api.get<T>(url, config);
      return response.data;
    } catch (error: any) {
      // ✅ Only show toast if skipToast is false or undefined
      // if (!options?.skipToast && error?.response?.data?.message) {
      //   toast.error(error?.response?.data?.message);
      // }
      throw handleApiError(error);
    }
  },

  post: async <T>(
    url: string,
    data?: any,
    options?: RequestOptions,
  ): Promise<T> => {
    try {
      const config = getRequestConfig(data, options);
      const response = await api.post<T>(url, data, config);
      return response.data;
    } catch (error: any) {
      // ✅ Only show toast if skipToast is false or undefined
      // if (!options?.skipToast && error?.response?.data?.message) {
      //   toast.error(error?.response?.data?.message);
      // }
      throw handleApiError(error);
    }
  },

  put: async <T>(
    url: string,
    data?: any,
    options?: RequestOptions,
  ): Promise<T> => {
    try {
      const config = getRequestConfig(data, options);
      const response = await api.put<T>(url, data, config);
      return response.data;
    } catch (error: any) {
      // ✅ Only show toast if skipToast is false or undefined
      // if (!options?.skipToast && error?.response?.data?.message) {
      //   toast.error(error?.response?.data?.message);
      // }
      throw handleApiError(error);
    }
  },

  delete: async <T>(url: string, options?: RequestOptions): Promise<T> => {
    try {
      const config = getRequestConfig(undefined, options);
      const response = await api.delete<T>(url, config);
      return response.data;
    } catch (error: any) {
      // ✅ Only show toast if skipToast is false or undefined
      // if (!options?.skipToast && error?.response?.data?.message) {
      //   toast.error(error?.response?.data?.message);
      // }
      throw handleApiError(error);
    }
  },
};